import { IOption } from '@bpba/form-components';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

export enum CUENTA_ORIGEN_ID {
  CBU_EXISTENTE = 1,
  CBU_NUEVO = 2,
  ALIAS_NUEVO = 3,
}

export const ORIGIN_FORM_KEY = 'origen';

const ORIGIN_OPTION_EXISTING = { id: CUENTA_ORIGEN_ID.CBU_EXISTENTE, label: 'CBU existente' };
const ORIGIN_OPTION_NEW = { id: CUENTA_ORIGEN_ID.CBU_NUEVO, label: 'Nuevo CBU' };
const ORIGIN_OPTION_ALIAS = { id: CUENTA_ORIGEN_ID.ALIAS_NUEVO, label: 'Nuevo alias' };

type OriginForm = {
  origen: IOption;
};

/**
 * Hook que provee datos necesarios para el selector de
 * tipo de CBU.
 * @param hasCBU - indica si el cliente tiene algún CBU
 * registrado. Si esto ocurre, se habilita la opción para
 * elegir alguno de los CBU ya registrados.
 */
export const useCBUorigin = (hasCBU: boolean) => {
  const formCbuMethods = useForm<OriginForm>({ values: { origen: ORIGIN_OPTION_NEW } });
  const currentOrigin = formCbuMethods.watch(ORIGIN_FORM_KEY).id;

  useEffect(() => {
    if (hasCBU) {
      formCbuMethods.setValue(ORIGIN_FORM_KEY, ORIGIN_OPTION_EXISTING);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasCBU]);

  const origenesCBU = [...(hasCBU ? [ORIGIN_OPTION_EXISTING] : []), ORIGIN_OPTION_NEW, ORIGIN_OPTION_ALIAS];

  return [origenesCBU, currentOrigin, formCbuMethods] as const;
};
